import { useCallback, useEffect, useState } from 'react';
import { PanelItemProps } from './SignaturePanel.types';
import FileUpload from '~/components/FileUpload';
import type { DeletionCommand, S3File } from '~/lib/Api.types';

type SignatureUploadProps = PanelItemProps;

const SignatureUpload = ({
    readOnly,
    onSignatureChanged,
    className,
}: SignatureUploadProps) => {
    const [selectedFile, setSelectedFile] = useState<File | DeletionCommand>();

    const onFileSelected = useCallback(
        async (file: S3File | File | { delete: boolean }) => {
            if (file && !(file as { delete: boolean }).delete) {
                setSelectedFile(file as File);
            } else {
                setSelectedFile({ delete: true });
            }
        },
        [],
    );

    useEffect(() => {
        if ((selectedFile as DeletionCommand)?.delete) {
            onSignatureChanged(null);
        } else if (selectedFile) {
            onSignatureChanged(selectedFile as File);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedFile]);

    return (
        <div className={`flex items-center ${className}`}>
            <FileUpload
                value={selectedFile}
                disabled={readOnly}
                onChange={onFileSelected}
                className="flex grow justify-center items-center"
                buttonClassName="form-button"
                id="signature-file-upload"
                accept="image/*"
                skipUploadingFile
            />
        </div>
    );
};
export default SignatureUpload;
